import { render, staticRenderFns } from "./ReviewCarousel.vue?vue&type=template&id=8df51da8&scoped=true"
import script from "./ReviewCarousel.vue?vue&type=script&lang=js"
export * from "./ReviewCarousel.vue?vue&type=script&lang=js"
import style0 from "./ReviewCarousel.vue?vue&type=style&index=0&id=8df51da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df51da8",
  null
  
)

export default component.exports